<template>
    <div class="pm-left" ref="pmRight">
        <canvas id="canvas" v-loading="loading"></canvas>

        <div v-if="isEdit" class="corner-btn">{{ $t('integration.editing_mode') }}</div>

        <!-- 右键删除 -->
        <div v-if="deletePoint"
             @contextmenu.prevent
             class="tooltips-div color-theme border bg-white"
             :style="{top: deletePoint.pos.y + 20 + 'px', left: deletePoint.pos.x + 'px'}"
        >
            <i class="el-icon-circle-close color-red font-16" style="position: absolute; top:5px; right:5px;z-index: 999;cursor: pointer;" @click="deletePoint = null"></i>
            <div>
                <el-button @click="handleDelConfirm">{{ $t('integration.delete_anchor_points') }}</el-button>
            </div>
        </div>

        <!-- tooltips -->
        <div
            v-if="point"
            @contextmenu.prevent
            class="tooltips-div color-theme border bg-white"
            :style="{top: point.y + 'px', left: point.x + 'px'}"
        >
            <i class="el-icon-circle-close color-red font-16" style="position: absolute; top:5px; right:5px;z-index: 999;cursor: pointer;" @click="close_detail"></i>
            <div>
                <p class="mb-10">
                    <i v-if="!point.ex && point.on" class="el-icon-circle-check color-green" :title="$t('integration.equipment')"></i>
                    <i v-else class="el-icon-warning-outline color-red" :title="$t('integration.equipment')"></i>
                    {{point.code}}
                </p>
                <p v-if="point.setup != null " class="mb-10">
                    <i class="el-icon-price-tag" :title="$t('integration.installation_point')"></i>{{point.setup}}
                </p>
                <p class="mb-10" v-if="!point.range">
                    <i class="el-icon-time" :title="$t('integration.time')"></i>{{$timetransition(point.time)}}
                </p>
                <div v-if="point.range" class="uk-flex mb-10" v-for="(item,index) in point.range" style="display: flex;justify-content: center;flex-flow: row;">
                    <div>
                        <p class="mb-10">
                            <i class="el-icon-time" :title="$t('integration.time')"></i>{{$timetransition(point.time)}}
                        </p>
                        <p class="mb-10 font-14" style="color: #000;text-align: center;cursor: pointer;" @click="show_more" :title="$t('integration.see_line_data')">
                            <i :class="[{'el-icon-caret-top':item.ex === 1},{'el-icon-caret-bottom':item.ex === 2},{'icon-up':item.ex === 1},{'icon-down':item.ex === 2}]"></i>{{item.val}}
                        </p>
                        <p style="text-align: center;">{{item.range}}</p>
                    </div>
                </div>
                <div class="uk-flex mb-10" v-if="point.description">
                    <div>
                        <p>
                            <i class="el-icon-document"></i>{{point.description}}
                        </p>
                    </div>
                </div>
                <p style="text-align: right;">
                    <span class="under-line" @click="show_more">{{$t('integration.click_to_see_more')}}</span>
                </p>
            </div>
        </div>
        <!--        <gatewayDetail :show.sync="gatewayDetailShow" ></gatewayDetail>-->
        <!--        <displayDetailDialog :isDetailShow.sync="displayDetailShow" />-->
        <!--        <relayDetailDialog :show.sync="relayDetailShow"></relayDetailDialog>-->
        <!--        <BaseDetailDialog :show.sync="baseDetailShow"></BaseDetailDialog>-->
    </div>
</template>

<script>
import bus from '@/utils/bus.js';
import { getInstance, PLAN_INFO_TYPE } from '@/utils/planUtil-mf.js';
import CarrierImage from '@/pages/home/component/planeMap/carrierImage.vue'
import { carrierDetail } from '@/api/modules/carrier'
import { sensorHistoryQueryFormat } from '@/utils/simplify/query'
import { sensorHistory } from '@/utils/winDetail'
import displayDetailDialog from '@/components/dialog/displayDetail/displayDetailDialog.vue'
import BaseDetailDialog from '@/components/dialog/baseDetail/baseDetailDialog.vue'
import gatewayDetail from '@/components/dialog/gatewayDetail/gatewayDetailDialog.vue'
import relayDetailDialog from '@/components/dialog/relayDetail/relayDetailDialog.vue'
import { sensorGetSensorDetailInfo } from '@/api/modules/sensor'
export default {
    components: { relayDetailDialog, gatewayDetail, BaseDetailDialog, displayDetailDialog, CarrierImage },
    props: ['pmObj', 'treeObj', 'newInfo', 'loading', 'type'],
    watch: {
        pmObj: {
            handler(newVal) {
                if (newVal && newVal.id) {
                    const that = this
                    that.$nextTick(() => {
                        that.onPmObjRefresh(newVal)
                    })
                }
            },
            immediate: true,
            deep: true
        },
        // 选择监测点渲染
        newInfo(newVal) {
          this.onNewInfo(newVal)
        }
    },
    computed: {
        PLAN_INFO_TYPE() {
            return PLAN_INFO_TYPE
        },
        positionList() {
            return this.type === PLAN_INFO_TYPE.DEVICE ? this.pmNewObj.devicePositionList : this.pmNewObj.carrierPositionList
        }
    },
    data() {
        return {
            // canvas对象
            myCanvas: null,
            // canvas 上下文
            canvasCtx: null,
            // 传递的数据
            pmNewObj: {},
            // 借用老版本的类
            planModule: null,
            // 所有的挂载点数据
            pointList: [],
            // 监测点数据
            info: '',
            Img: '',
            down: false,
            isMove: true,
            isWheelZoom: true,
            isEdit: false,
            delVisible: false,
            deletePoint: null,

            // 当前鼠标移动到选择的点，显示tooltip的描点
            selectPoint: null,
            point: null,
            carrierDetailObj: {},

            gatewayDetailShow: false,
            displayDetailShow: false,
            relayDetailShow: false,
            baseDetailShow: false
        };
    },
    mounted() {
        bus.$on('refreshPoint', array => {
            this.close_detail()
            this.planModule.refresh(true);
            this.putPoint(array);
        });
        bus.$on('uploadFile', base64 => {
            this.pmNewObj.base64Path = base64;
            this.planModule.setData([], true, true);
            this.initImage(base64);
        });
        bus.$on('updatePmObjPoint', pointList => {
            console.log($t('integration.point_data_arrival_c'), pointList);
            if (this.type === PLAN_INFO_TYPE.DEVICE) {
                this.pmNewObj.devicePositionList = pointList;
            } else {
                this.pmNewObj.carrierPositionList = pointList;
            }

        });

        this.zoomFns();
        this.delPoints();
        this.isEditFn();
    },
    beforeDestroy() {
        bus.$off('refreshPoint');
        bus.$off('uploadFile');
        bus.$off('zoomFn');
        bus.$off('delPoint');
        bus.$off('isEditFn');
        bus.$off('updatePmObjPoint');
    },
    methods: {
        onPmObjRefresh(newVal) {
            console.log('pmObj: ', newVal)
            this.pmNewObj = { ...newVal }
            this.clearPlanModule()
            this.initCanvas()
        },
        onNewInfo(newVal) {
            console.log('newInfo: ', newVal)
            this.info = newVal ? { ...newVal } : null
            this.replayAnchor()
        },
        clearPlanModule() {
            if (this.planModule) this.planModule.clear()
        },
        replayAnchor() {
            const param = { nameParam: 'title', statusParam: 'abnormal' }
            const list = this.positionList ? [...this.positionList] : []
            const idx = list.findIndex(i => i.id === this.info?.id)
            this.initPoint(list, { active: idx, ...param })
        },
        isEditFn() {
            bus.$on('isEditFn', bool => {
                this.isEdit = bool;
                this.close_detail()
                this.clearRect();
                this.initParam(bool);
            });
        },
        initCanvas() {
            this.myCanvas = document.querySelector('#canvas');
            this.canvasCtx = this.myCanvas.getContext('2d');
            this.myCanvas.height = this.$refs.pmRight.offsetHeight - 20;
            this.myCanvas.width = this.$refs.pmRight.offsetWidth - 20;
            this.initParam();
        },
        // 清除画布
        clearRect() {
            this.canvasCtx.clearRect(0, 0, this.myCanvas.width, this.myCanvas.height);
        },
        // 绘制画布
        initParam(bool) {
            const that = this;
            that.$nextTick(function() {
                if (!that.planModule) {
                    // 为拖动判定做标记
                    that._isDragging = false;
                    that.planModule = getInstance({
                        id: 'canvas',
                        move: that.isMove, // 是否可移动
                        wheelZoom: that.isWheelZoom, // 是否可缩放
                        dotInfo: true, // 是否显示点信息
                        mouseup: async (img, down, drop, data, x, y, pos, target, e) => {
                            that.close_detail()

                            that.selectPointFn(target, e)

                            // 非左键
                            if (e.button !== 0) return

                            // 是否开启编辑
                            if (!that.isEdit) return

                            // 如果拖动过就不走定点逻辑
                            if (drop) return

                            if (target) return

                            if (!that.info) return that.$message.warning($t('integration.carrier_cannot_be_empty'));

                            // 判断设备是否已绑定其他平面图
                            if (that.info.type === PLAN_INFO_TYPE.DEVICE &&
                                that.info.obj?.scenePlanId &&
                                that.info.obj.scenePlanId !== that.pmObj.planId) {
                                try {
                                    await that.$confirm(that.$t('integration.device_plan_location_tips'));
                                } catch {
                                    // 用户点击“取消”
                                    return;
                                }
                            }

                            let temp = {};

                            if (data) {
                                const idx = data.findIndex(item => item.id === that.info.id);
                                temp = { xpos: x, ypos: y };
                                if (idx !== -1) {
                                    data[idx].xpos = x;
                                    data[idx].ypos = y;
                                } else {
                                    temp.idx = idx;
                                    temp.xpos = x;
                                    temp.ypos = y;
                                    temp.type = that.type;
                                    temp.title = that.info.title;
                                    temp.id = that.info.id;
                                    temp.obj = that.info.obj;
                                    data.push(temp);
                                }

                                that.$emit('xyPosFn', temp);
                                bus.$emit('position', temp)
                            }

                            that.planModule.drawImg('title', 'abnormal');
                        },
                        mousemove: (down, drop, data, pos, target, e) => {
                            if (target) {
                                if (that.isEdit) return

                                const hit = target.data
                                const screenX = target.pos.x
                                const screenY = target.pos.y

                                if (!that.selectPoint || that.selectPoint.id !== hit.id) {
                                    console.log(target.data)
                                    if (that.type === that.PLAN_INFO_TYPE.DEVICE) {
                                        that.selectPoint = {
                                            ...hit,
                                            xpos: screenX,
                                            ypos: screenY + 20
                                        }
                                        that.show_detail()
                                    } else {
                                        that.selectPoint = {
                                            ...hit.obj,
                                            id: hit.id,
                                            xpos: screenX,
                                            ypos: screenY + 20
                                        }
                                        // that.getCarrierDetail()
                                    }
                                }
                            }
                        }
                    });
                }

                // base64赋值到画布
                this.initImage();
                this.putPoint(this.positionList)
            });
        },
        putPoint(array) {
            this.planModule.setData([], true, true);
            // 如果存在锚点
            if (array.length > 0) {
                const param = {
                    nameParam: 'title',
                    statusParam: 'abnormal',
                    // color: 'var(--primary-color)'
                };
                this.initPoint(array, param);
            }
        },
        windowToCanvas(canvas, x, y) {
            const box = canvas.getBoundingClientRect();
            return {
                x: x - box.left - (box.width - canvas.width) / 2,
                y: y - box.top - (box.height - canvas.height) / 2
            };
        },
        initImage(img) {
            this.planModule.draw([], img || this.pmNewObj.base64Path || '0');
        },
        initPoint(array = [], param) {
            if (!this.planModule) return
            // 设备锚点名称字段
            this.planModule.flashing = this.isEdit
            this.planModule.setData([], true, true, param);
            if (!array) return;
            this.planModule.setData(array, true, true, param);

            // return new Promise(resolve => {
            //     setTimeout(() => {
            //         this.planModule.setData(array, true, true, param);
            //         resolve();
            //     }, 50);
            // });
        },
        // 缩放
        zoomFns() {
            bus.$on('zoomFn', value => {
                if (value < 0) {
                    // 缩小
                    this.planModule.zoomOut(Math.abs(value));
                } else if (value > 0) {
                    // 放大
                    this.planModule.zoomIn(value);
                } else {
                    this.planModule.zoomIn(value);
                }
            });
        },
        // 移除锚点
        delPoints() {
            bus.$on('delPoint', () => {
                this.planModule.setData([], true, true);
            });
        },
        // 点击锚点
        selectPointFn(target, e) {
            if (target) {
                if (e.button === 0) {
                    bus.$emit('selectItemFn', target.data)
                } else if (e.button === 2 && this.isEdit) {
                    bus.$emit('selectItemFn', target.data)
                    this.close_detail()
                    this.deletePoint = target
                }
            }
        },
        handleDelConfirm() {
            if (this.deletePoint)
            bus.$emit('delPosition', this.deletePoint.data)
            this.deletePoint = null
        },

        // 鼠标悬浮显示锚点信息
        closeSelectPoint() {
            this.selectPoint = null
        },
        // 获取监测点detail
        getCarrierDetail() {
            carrierDetail(this.selectPoint.carrierTypeId, this.selectPoint.carrierId).then(res => {
                this.carrierDetailObj = res.result
            })
        },
        show_detail() {
            this.point = null;
            let item = {...this.selectPoint.obj}

            let pos = {
                dev_id: item.deviceId,
                dev: item.deviceCatalog,
                type: item.deviceType,
                is_circle: item.deviceCatalog !== 1,
                ex: false
            }
            pos.code = item['deviceCode']
            pos.time = item['updateTime']
            pos.description = item['description']
            pos.left = item.xpos - (item.deviceCatalog == 0 ? 6 : 10)
            pos.top = item.ypos - (item.deviceCatalog == 0 ? 6 : 10)
            if (item.deviceCatalog == 0) {
                pos.type_desc = (item.deviceType % 2 === 0 ? 'H' : 'T') + (item.deviceType % 2 === 0 ? item.deviceType - 1 : item.deviceType)
            } //探头（温湿度）
            if (item.deviceCatalog == 1) {
                pos.type_desc = item.deviceType == 1 ? 'G' : (item.deviceType == 2 ? 'G1' : 'G2')
            } //网关
            if (item.deviceCatalog == 2) {
                pos.type_desc = 'D' + item.deviceType
            } //显示屏
            if (item.deviceCatalog == 3) {
                pos.type_desc = 'R' + item.deviceType
            } //中继
            if (item.deviceCatalog == 5) {
                pos.type_desc = 'G' + item.deviceType
            } //气体
            if (item.deviceCatalog == 6) {
                pos.type_desc = 'M' + item.deviceType
            } //门磁
            pos.on = item.deviceStatus == 1
            if ('mountPointName' in item) {
                pos.setup = item['mountPointName']
            }
            let probe = null
            pos.probe_val = []
            if ('probe' in item) {
                probe = JSON.parse(item.probe)
                if (item.deviceCatalog == 0) {
                    pos.probe_val.push({ key: 'temp', val: probe['temp']['val'], unit: '℃' })
                    if (item.deviceType % 2 === 0) {
                        pos.probe_val.push({ key: 'hum', val: probe['hum']['val'], unit: '%RH' })
                    }
                }
                if (item.deviceCatalog == 5) {
                    pos.probe_val.push(item.deviceType == 6 ? {
                        key: 'coz',
                        val: probe['coz']['val'],
                        unit: '%VOL'
                    } : { key: 'gas', val: probe['gas']['val'], unit: probe['gas']['unit'] })
                }
                if (item.deviceCatalog == 6) {
                    pos.probe_val.push({
                        key: 'magnetism',
                        val: probe['magnetism']['val'] == 0 ? 'OFF' : 'ON',
                        unit: ''
                    })
                }
            }
            if ('probeRange' in item && 'rangeList' in item) {
                pos.range = []
                item.rangeList.forEach((k, i) => {
                    let meaning = {
                        code: k['unitCode'],
                        range: (k['min'] + k['unitName'] + '~' + k['max'] + k['unitName']),
                        val: probe != null ? probe[k.unitCode]['val'] + k['unitName'] : '---'
                    }
                    if (probe != null && ((!pos.ex) && (probe[k.unitCode]['val'] > k['max'] || probe[k.unitCode]['val'] < k['min']))) {
                        pos.ex = true
                        meaning.ex = probe[k.unitCode]['val'] > k['max'] ? 1 : (probe[k.unitCode]['val'] < k['min'] ? 2 : 0)
                        pos.probe_val.forEach((it, no) => {
                            if (it.key == k.unitCode && it.val > k['max']) {
                                it.ex = 1
                            }
                            if (it.key == k.unitCode && it.val < k['min']) {
                                it.ex = 2
                            }
                        })
                    }
                    pos.range.push(meaning)
                })
            }

            this.point = pos
            this.point.x = this.selectPoint.xpos;
            this.point.y = this.selectPoint.ypos;
        },
        // 打开设备历史曲线图页面
        toDeviceHistory() {
            let row = this.selectPoint.obj
            // 区分如果是传感器类那种就到历史曲线，不是就到详情（比如网关详情）
            if (row.deviceCatalog === 0 || row.deviceCatalog === 5 || row.deviceCatalog === 6) {
                const params = sensorHistoryQueryFormat(this.selectPoint)
                // 因为传感器写的历史数据的组件接口请求参数的值no:tag_id,气体么有tag_id，使用gas_code
                params.tagId = row.deviceCode
                // 因为传感器写的历史数据的组件接口请求参数的值devCatalog直接写的0,气体要格外增加一些参数修改
                // params.devCatalog = 5
                if (row.deviceCatalog === 5) {
                    if (row.deviceType === 6) {
                        params.probe = 'coz'
                    } else {
                        params.probe = 'gas'
                    }
                    params.devCatalog = 5
                } else if (row.deviceCatalog === 6) {
                    params.probe = 'magnetism'
                    params.devCatalog = 6
                }

                // 有些字段命名不一样
                params.scopeName = row.sceneName
                params.carrierName = row.carrierName
                params.carrierId = row.carrierId
                params.carrierTypeId = row.carrierType
                sensorHistory(params)
            } else {
                if (row.deviceCatalog === 1) {
                    bus.$emit('gatewayParam', row.deviceId, row.deviceCode)
                    // this.gatewayDetailShow = true
                } else if (row.deviceCatalog === 2) {
                    bus.$emit('displayParam', row.deviceId, row.deviceCode)
                    // this.displayDetailShow = true
                } else if (row.deviceCatalog === 3) {
                    bus.$emit('relayParam', row.deviceId, row.deviceCode)
                    // this.relayDetailShow = true
                } else if (row.deviceCatalog === 4) {
                    bus.$emit('baseParam', row.deviceId, row.deviceCode)
                    // this.baseDetailShow = true
                }
            }
        },
        show_more() {
            this.toDeviceHistory()
            // let row = this.point
            // // 区分如果是传感器类那种就到历史曲线，不是就到详情（比如网关详情）
            // if (row.dev == 0 || row.dev == 5 || row.dev == 6) {
            //     let params = {}
            //     sensorGetSensorDetailInfo(row.dev_id).then(({ result }) => {
            //         params.id = row.dev_id
            //         params.tagId = result.sensor.tagId
            //         params.scopeName = result.sensor.scopeName
            //         if ('carrierName' in result.sensor) {
            //             params.carrierName = result.sensor.carrierName
            //             params.carrierId = result.sensor.carrierId
            //             params.carrierTypeId = result.sensor.carrierType
            //         }
            //         params.description = result.sensor.description
            //         if (row.dev == 0) {
            //             params.probe = row.code == 'temp'
            //         }
            //         if (row.dev == 5) {
            //             params.probe = row.type == 6 ? 'coz' : 'gas'
            //         }
            //         if (row.dev == 6) {
            //             params.probe = 'magnetism'
            //         }
            //         params.devCatalog = row.dev
            //         sensorHistory(params)
            //     })
            // } else {
            //     if (row.dev == 1) {
            //         bus.$emit('gatewayParam', row.dev_id, row.code)
            //         // this.gatewayDetailShow = true
            //     } else if (row.dev == 2) {
            //         bus.$emit('displayParam', row.dev_id, row.code)
            //         this.displayDetailShow = true
            //     } else if (row.dev == 3) {
            //         bus.$emit('relayParam', row.dev_id, row.code)
            //         this.relayDetailShow = true
            //     } else if (row.dev == 4) {
            //         bus.$emit('baseParam', row.dev_id, row.code)
            //         this.baseDetailShow = true
            //     }
            //
            // }
        },
        close_detail() {
            this.point = null
            this.selectPoint = null
            this.deletePoint = null
        }
    }
};
</script>

<style lang="scss" scoped>
.pm-left {
    flex: 1;
    padding: 10px;
    box-sizing: border-box;
    color: transparent;
    border: 1px solid #ccc;
    width: 100%;
    height: 100%;
    position: relative;
    .tooltips-div{
        position: absolute;
        padding: 20px;
    }
}
.corner-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #f59a23;
    color: white;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    z-index: 10;
}
</style>
